module.exports = __webpack_public_path__ + "img/allowances-plans.f24cdb5b.svg";